import { all, fork, put } from 'redux-saga/effects';

import api from 'gateway';
import getUserMarkers from '../../gateway/settings/getUserMarkers';
import { getMarkers, createMarker, deleteMarker } from 'services/learnkit';

import { SAVE_MARKERS } from 'reducers/dataModels/markers';
import { SAVE_DEFAULT_SELECTEDHIGHLIGHT } from 'reducers/dataModels/selectedHighlight';

function sortMarkers(markers) {
  return markers.sort((a, b) => {
    return a.sortOrder > b.sortOrder;
  });
}

function* deleteMarkers(markers) {
  const deleteMarkerCalls = markers.map(marker => deleteMarker(marker.globalId));
  yield Promise.all(deleteMarkerCalls);
}

function getDefaultSelectedHighlight(marker) {
  return {
    color: marker.color,
    darkColor: marker.darkColor,
    id: '',
    label: marker.label,
    markerId: marker.id,
    noteText: ''
  };
}

/**
 * Determine which markers should be added/deleted from vitalsource,
 * as well as collect all user markers to pass to redux state
 */
export function filterMarkers(vsMarkers, userMarkers) {
  // LST-165: never delete VS markers
  let deleteVsMarkers = [];

  // LST-1528 determine which colors are missing from userMarkers, so they can be added to VS
  const vsColors = vsMarkers.map(m => m.color);
  let addVsMarkers = userMarkers.filter(m => !vsColors.includes(m.color));

  // collect all the markers to pass to redux state
  let userMarkersToSetState = [...vsMarkers, ...addVsMarkers];

  return { addVsMarkers, deleteVsMarkers, userMarkersToSetState };
}

export async function ensureMarkers() {
  const userMarkers = await getUserMarkers();
  const { markers: vsMarkers } = await getMarkers();
  const { addVsMarkers } = filterMarkers(vsMarkers || [], userMarkers);

  if (addVsMarkers.length > 0) {
    await Promise.all(addVsMarkers.map(marker => createMarker(marker)));
  }
}

function* markers(vsMarkers) {
  try {
    const userMarkers = yield api.settings.getUserMarkers();
    const { deleteVsMarkers } = filterMarkers(vsMarkers || [], userMarkers);

    if (!vsMarkers || vsMarkers.length === 0) {
      return;
    }

    const sortedMarkers = sortMarkers([...vsMarkers]);
    const defaultSelectedHighlight = getDefaultSelectedHighlight(sortedMarkers[0]);

    if (deleteVsMarkers.length > 0) {
      yield fork(deleteMarkers, deleteVsMarkers);
    }
    yield all([
      put({ type: SAVE_DEFAULT_SELECTEDHIGHLIGHT, data: defaultSelectedHighlight }),
      put({ type: SAVE_MARKERS, data: sortedMarkers })
    ]);
  } catch (err) {
    console.error('Normalize Markers:', err);
    debugger;
  }
}

export default markers;
